import React, { useState } from 'react';
import { ShoppingBagIcon, MenuIcon, XIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    totalItems,
    openCart
  } = useCart();
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-69">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between" data-id="element-70">
        <div className="flex items-center" data-id="element-71">
          <h1 className="text-2xl font-bold text-fuchsia-600" data-id="element-72">AI Shirts</h1>
        </div>
        <nav className="hidden md:flex space-x-8" data-id="element-73">
          <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium transition-colors" data-id="element-74">
            Women
          </a>
          <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium transition-colors" data-id="element-75">
            Men
          </a>
          <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium transition-colors" data-id="element-76">
            New Arrivals
          </a>
          <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium transition-colors" data-id="element-77">
            About
          </a>
        </nav>
        <div className="flex items-center space-x-4" data-id="element-78">
          <button aria-label="Shopping bag" className="relative p-2 text-gray-700 hover:text-fuchsia-600 transition-colors" onClick={openCart} data-id="element-79">
            <ShoppingBagIcon size={24} data-id="element-80" />
            <span className="absolute top-0 right-0 bg-fuchsia-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center" data-id="element-81">
              {totalItems}
            </span>
          </button>
          <button className="md:hidden p-2 text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-82">
            {isMenuOpen ? <XIcon size={24} data-id="element-83" /> : <MenuIcon size={24} data-id="element-84" />}
          </button>
        </div>
      </div>
      {isMenuOpen && <div className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-85">
          <nav className="flex flex-col space-y-4 py-2" data-id="element-86">
            <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium py-2 transition-colors" data-id="element-87">
              Women
            </a>
            <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium py-2 transition-colors" data-id="element-88">
              Men
            </a>
            <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium py-2 transition-colors" data-id="element-89">
              New Arrivals
            </a>
            <a href="#" className="text-gray-700 hover:text-fuchsia-600 font-medium py-2 transition-colors" data-id="element-90">
              About
            </a>
          </nav>
        </div>}
    </header>;
};